
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Berücksichtigt wurden für die Flugreise sowohl die direkten Emissionen aufgrund des verbrauchten Treibstoffs der Produktion des Flugzeugs und des Flughafens als auch zusätzliche klimawirksame Effekte aufgrund des Ausstosses an Gasen weit oben in der Atmosphäre. Der Gesamtkonsum einer in der Schweiz wohnhaften Person verursachte im Jahr 2015 durchschnittliche Treibhausgasemissionen von 15 Tonnen CO`}<sub>{`2`}</sub>{`-Äquivalenten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;